import { useEffect, useRef } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import customsClient, { getCustomsToken, setCustomsToken } from "@/lib/customsApi";
import CustomsLogin from "@/pages/CustomsLogin";
import CustomsDashboard from "@/pages/CustomsDashboard";

export default function CustomsApp() {
  const token = getCustomsToken();
  const timer = useRef(null);
  useEffect(() => {
    if (!token) return undefined;
    const reset = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => { setCustomsToken(null); window.location.assign("/customs"); }, 30 * 60 * 1000);
    };
    const evts = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    evts.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => { clearTimeout(timer.current); evts.forEach((e) => window.removeEventListener(e, reset)); };
  }, [token]);
  const { data: me, isLoading, isError } = useQuery({
    queryKey: ["customs-me", token],
    queryFn: async () => (await customsClient.get("/customs/me")).data,
    enabled: !!token,
    retry: false,
  });
  if (token && isLoading) {
    return <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC]"><Loader2 className="h-7 w-7 animate-spin text-primary" /></div>;
  }
  if (!token || isError || !me) return <CustomsLogin />;
  return (
    <Routes>
      <Route path="/customs" element={<CustomsDashboard me={me} />} />
      <Route path="/customs/:vid" element={<CustomsDashboard me={me} />} />
      <Route path="*" element={<Navigate to="/customs" replace />} />
    </Routes>
  );
}
